import { TradingEntity } from 'api'
import { sortBy } from 'lodash'
import { TradingEntityHelper } from 'model'
import React from 'react'
import { useSelector } from 'react-redux'
import { tradingEntityGetterSelector } from 'selectors/tradingEntitySelectors'
import { tradingRelationshipsGetterSelector } from 'selectors/tradingRelationshipSelectors'
import { Field } from 'view/components/inputs'
import { Selectbox, SelectboxProps } from 'view/components/options'

interface SubjectTradingEntitySelectboxProps
  extends Omit<SelectboxProps<TradingEntity, string>, 'optionKeys' | 'getOption' | 'getOptionText'> {
  ownerTradingEntityId: string | undefined | null
}

export const SubjectTradingEntitySelectbox = (props: SubjectTradingEntitySelectboxProps) => {
  const getTradingEntity = useSelector(tradingEntityGetterSelector)
  const getTradingRelationships = useSelector(tradingRelationshipsGetterSelector)

  const relationships = props.ownerTradingEntityId ? getTradingRelationships(props.ownerTradingEntityId) : []
  const relationshipIds = sortBy(
    relationships.map(r => (r.sellTradingEntity === props.ownerTradingEntityId ? r.buyTradingEntity : r.sellTradingEntity)),
    tradingEntityId => {
      const option = getTradingEntity(tradingEntityId)

      return option ? TradingEntityHelper.getName(option) : null
    }
  )

  return <Selectbox {...props} optionKeys={relationshipIds} getOption={getTradingEntity} getOptionText={TradingEntityHelper.getName} />
}

export const SubjectSelectboxField = Field(SubjectTradingEntitySelectbox)
